function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from "@material-ui/core/Button";
import { isEmpty } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AuthenticationFooter from "@common/components/authentication/AuthenticationFooter";
import { openWriteToUs } from "@common/actions";
import { DISABLE_WRITE_TO_US, ROUTE_SIGN_IN } from "@config/constants";
export var NoMatch = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(NoMatch, PureComponent);
    var _super = _create_super(NoMatch);
    function NoMatch(props) {
        _class_call_check(this, NoMatch);
        var _this;
        _this = _super.call(this, props);
        _this.redirectToLoginPage = _this.redirectToLoginPage.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(NoMatch, [
        {
            /**
     * Redirects to login page
     */ key: "redirectToLoginPage",
            value: function redirectToLoginPage() {
                this.props.history.push(ROUTE_SIGN_IN);
            }
        },
        {
            key: "render",
            value: function render() {
                var template = null;
                var _this_props = this.props, authentication = _this_props.authentication, i18n = _this_props.i18n, _$openWriteToUs = _this_props.openWriteToUs;
                if (isEmpty(i18n)) {
                    template = /*#__PURE__*/ _jsx("div", {
                        children: "Loading...."
                    });
                } else {
                    // If user is not logged in, there is a button redirecting to login page
                    var signInButton = null;
                    var footer = null;
                    if (!authentication.token) {
                        signInButton = /*#__PURE__*/ _jsx(Button, {
                            id: "sign-in-button",
                            onClick: this.redirectToLoginPage,
                            classes: {
                                label: "ux-button-label"
                            },
                            className: "no-match-sign-in-button button raised full-width margin-top-tiny",
                            children: i18n.authentication.signIn
                        });
                        footer = /*#__PURE__*/ _jsx(AuthenticationFooter, {
                            hasBackLink: false,
                            i18n: i18n
                        });
                    }
                    template = /*#__PURE__*/ _jsx("div", {
                        className: "page-wrapper",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "no-match-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "error-404",
                                    children: i18n.noMatchPage.error404
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "not-found-wrapper",
                                    children: i18n.noMatchPage.contentCannotBeFound
                                }),
                                !DISABLE_WRITE_TO_US && /*#__PURE__*/ _jsxs("div", {
                                    className: "need-help",
                                    children: [
                                        i18n.noMatchPage.needHelp,
                                        /*#__PURE__*/ _jsxs("span", {
                                            onClick: _$openWriteToUs,
                                            className: "write-to-us",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "icon icon-contact-us"
                                                }),
                                                i18n.writeToUs
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("img", {
                                    className: "no-match-image",
                                    src: "/assets/media/error-404.png",
                                    alt: i18n.writeToUs
                                }),
                                signInButton,
                                footer
                            ]
                        })
                    });
                }
                return template;
            }
        }
    ]);
    return NoMatch;
}(PureComponent);
var mapStateToProps = function(param) {
    var authentication = param.authentication;
    return {
        authentication: authentication
    };
};
export default withRouter(connect(mapStateToProps, {
    openWriteToUs: openWriteToUs
})(NoMatch));
